<!-- <mat-card> -->
<mat-card-content>
  <div class="text-center">
    <!-- <img alt="homepage" src="assets/images/logo-icon.png" /> -->

    <div style="width: 60%; padding: 5px; margin: 0 auto">
      <img
        alt="homepage"
        src="https://wikipapa.org/images/wikipapa-logo2.png"
        width="100%"
      />
    </div>

    <!-- https://wikipapa.org/images/wikipapa-logo2.png -->

    <!-- <h4 class="m-t-0">Register to GIZ</h4> -->
  </div>
  <br />
  <div>
    <mat-form-field appearance="outline">
      <mat-label>Correo electrónico</mat-label>
      <input
        matInput
        placeholder="Correo electrónico"
        [formControl]="username"
        type="text"
        autocomplete="on"
      />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Contraseña</mat-label>
      <input
        matInput
        [formControl]="password"
        placeholder="Contraseña"
        [type]="hide ? 'password' : 'text'"
        autocomplete="on"
        required
      />
      <button mat-icon-button matSuffix (click)="hide = !hide">
        <mat-icon> {{ hide ? "visibility_off" : "visibility" }}</mat-icon>
      </button>
    </mat-form-field>
    <br />
    <br />
    <div class="actions">
      <div fxFlex="100">
        <section class="example-section">
          <mat-checkbox [(ngModel)]="remember"> Recordarme </mat-checkbox>
        </section>
      </div>
    </div>

    <div class="actions">
      <button
        fxFlex="100"
        mat-raised-button
        color="primary"
        (click)="signIn()"
        [disabled]="!username.valid || !password.valid"
        [mat-dialog-close]="true"
      >
        Acceder
      </button>
    </div>

    <!-- <div class="actions align-text-center">
      <mat-label>¿No tienes una cuenta?</mat-label>
      <button mat-button color="primary" (click)="goSignUp()">
        Crear una cuenta
      </button>
    </div> -->
  </div>
</mat-card-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>Cerrar</button>
</mat-dialog-actions>

<!-- </mat-card> -->
